/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){

    $('.js-recover-password').on('click', function(){
      $('#login').hide();
      $('#recover').show();
    });

    $('.cancel-recover-password').on('click', function(){
      $('#recover').hide();
      $('#login').show();
    });

    $('.js-recover-password').click(function(){
        $('.reset_heading').show() && $('.account__title').hide();
    });
    $('.cancel-recover-password').click(function(){
        $('.reset_heading').hide() && $('.account__title').show();
    });

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;